<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div v-if="!loading && records.length">
          <table class="table table-sm table-hover mt-1">
            <thead></thead>
            <tbody>
            <template v-for="rev in records">
              <tr>
                <td colspan="10"><strong>{{ printDate(rev.date, 'DD.MM.YYYY') }}</strong></td>
              </tr>
              <tr v-for="(d, i) in rev.divisions">
                <td>{{ i + 1 }}</td>
                <td>{{ $AllDivisions[d.division_id]?.title }}</td>
                <td>
                  <UserName :id="d.user_id" v-if="d.user_id"/>
                </td>
                <td>{{ $AllCurrencies[d.currency_id]?.currency }}: <strong>{{ d.sum.toLocaleString('ru-RU') }}</strong></td>
                <td>{{ d.extra_currencies}}</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import UserName from "@/components/users/UserName.vue";

export default {
  components: {UserName},
  data() {
    return {
      loading: false,
      records: [],
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    }
  },
  mounted() {
    this.getRecords();
  },
  methods: {
    async getRecords() {
      this.loading = true;
      const {data} = await api.index('/revision/divisions');
      if (data.success) {
        this.records = Object.values(data.records).reverse();
      } else {
        toastr["warning"](data.message || "ошибка сервера", "Неуспешно");
      }
      this.loading = false;
    }
  }
}

</script>
